import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Form, Button } from 'react-bootstrap';

import { BookOnlineContext } from '../context';

const ServiceList = () => {
  const { services, isBusiness, cartItems, cartTotal, setIsBusiness, setCartItems, setCartTotal } = useContext(BookOnlineContext);
  const [tooltip, setTooltip] = useState(false);
  const tooltipBookingType = { BOOKING_TYPE_SWITCH: 1 };

  useEffect(() => {
    const retrievedTooltip = JSON.parse(localStorage.getItem('tooltipBookingType'));
    if (retrievedTooltip !== null && retrievedTooltip.BOOKING_TYPE_SWITCH === 1) {
      setTooltip(false);
    } else {
      setTooltip(true);
    }

    const cartData = services.filter(service => cartItems.includes(service.id));
    let subTotal = 0;
    for (let i = 0; i < cartData.length; i++) {
      subTotal += isBusiness ? cartData[i].businessPrice : cartData[i].homePrice;
    }

    setCartTotal(subTotal);
  }, [services, isBusiness, cartItems, setCartTotal]);

  const handleAddCart = (id) => {
    setCartItems([ ...cartItems, id ]);
    calculateSubTotal(id, true);
  }

  const handleRemoveCart = (id) => {
    const restItems = cartItems.filter(item => item !== id);
    setCartItems(restItems);
    calculateSubTotal(id, false);
  }

  const calculateSubTotal = (id, isSummation) => {
    let subTotal = cartTotal;
    if (isSummation) {
      subTotal += isBusiness ? services.find(item => item.id === id).businessPrice : services.find(item => item.id === id).homePrice;
    } else {
      subTotal -= isBusiness ? services.find(item => item.id === id).businessPrice : services.find(item => item.id === id).homePrice;
    }

    setCartTotal(subTotal);
  }

  const handleTrigger = () => {
    setTooltip(false);
    localStorage.setItem('tooltipBookingType', JSON.stringify(tooltipBookingType));
  }

  if (services && services.length > 0) {
    return (
      <Fragment>
        <div className="BookingForm-List__Topbar">
          <Form.Label className="text-info">Is the service needed for business?</Form.Label>
          <Form.Check 
            type="switch"
            id="userType"
            label={isBusiness ? 'Yes! For business setup.' : 'No! For home environment.'}
            checked={isBusiness}
            onChange={(event) => setIsBusiness(event.currentTarget.checked)}
          />
          {
            tooltip &&
              <div className="GuestTooltip sm left">
                <p>By clicking here, you can select booking type as Home or Business at anytime.</p>
                <div className="w-100 d-block text-right">
                  <Button
                    size="sm"
                    variant="light"
                    onClick={handleTrigger}
                  >Okay</Button>
                </div>
              </div>
          }
        </div>
        <ul className="BookingForm-List">
          {
            services.map(service => (
              <li key={service.id} className="BookingForm-List__Item">
                <div className="d-block d-md-flex">
                  <div className="BookingForm-List__Item--Content">
                    <h4 className="BookingForm-List__Item--Name">{service.name}</h4>
                    <p className="BookingForm-List__Item--Price">
                      ${isBusiness ? service.businessPrice : service.homePrice} <span>/ hr.</span>
                    </p>
                  </div>
                  <div className="BookingForm-List__Item--Action">
                    {
                      cartItems.find(item => item === service.id) ?
                        <Button
                          size="sm"
                          variant="outline-danger"
                          className="rounded-pill"
                          onClick={() => handleRemoveCart(service.id)}
                        >Remove -</Button> :
                        <Button
                          size="sm"
                          variant="outline-success"
                          className="rounded-pill"
                          onClick={() => handleAddCart(service.id)}
                        >Add +</Button>
                    }
                  </div>
                </div>
              </li>
            ))
          }
        </ul>
      </Fragment>
    );
  }

  return null;
};

export default ServiceList;